<template>
    <button @click="player.fullscreen = !player.fullscreen"
            :class="{'pp-ui-button': applyStyles, 'pp-ui-button-play': applyStyles}">
        <slot>
            <IconEnter v-if="!player.fullscreen"/>
            <IconExit v-else/>
        </slot>
    </button>
</template>

<script>
  import {PPComponentMixin} from "../mixins";
  import IconEnter from '../style/assets/fullscreen.svg';
  import IconExit from '../style/assets/fullscreen_exit.svg';

  export default {
    name: "PPButtonToggleFullscreen",
    mixins: [PPComponentMixin],
    components: {IconEnter, IconExit}
  }
</script>
